import { httpClient } from '@/modules/common/services/http/http-client';

const bffTradingBaseURL = `${process.env.VUE_APP_BFF_URL}/trading/v1`;
export const httpClientBffTrading = httpClient.withOptions({
  baseURL: bffTradingBaseURL
});

export function postCopytradeToken(): Promise<{ token: string }> {
  return httpClientBffTrading.post('/copy-trade/generate-token');
}
